import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import { IconCrossSmall } from '~/ui/core/icons';

type ChatHeaderProps = {
    readonly onClose: () => void;
};

export const ChatHeader: FunctionComponent<ChatHeaderProps> = ({ onClose }) => {
    const translate = useTranslate();

    return (
        <div className="flex w-full shrink-0 items-center gap-m p-0 pb-xxl pt-xxl">
            <Button aria-label={translate('common.close')} iconOnly={true} size="xs" variant="round" onClick={onClose}>
                <IconCrossSmall />
            </Button>
            <span className="text-sm font-medium tracking-tight text-black-900">{translate('chat.new-chat')}</span>
        </div>
    );
};
